var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.optionModel.name
    ? _c(
        "el-form-item",
        { attrs: { prop: "name", rules: _vm.nameRequiredRule } },
        [
          _c(
            "span",
            { attrs: { slot: "label" }, slot: "label" },
            [
              _vm._v(
                _vm._s(_vm.i18nt("designer.setting.uniqueName")) + "\n    "
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "light",
                    content: _vm.i18nt("designer.setting.editNameHelp"),
                  },
                },
                [_c("i", { staticClass: "el-icon-info" })]
              ),
            ],
            1
          ),
          _vm._v(" "),
          [
            _c("el-input", {
              attrs: { type: "text", readonly: _vm.widgetNameReadonly },
              on: { change: _vm.updateWidgetNameAndRef },
              model: {
                value: _vm.optionModel.name,
                callback: function ($$v) {
                  _vm.$set(_vm.optionModel, "name", $$v)
                },
                expression: "optionModel.name",
              },
            }),
          ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }